// extracted by mini-css-extract-plugin
module.exports = {"list":"ClientBonusAllowancesForm__list--2chGh"};